import { Controller } from "@hotwired/stimulus";
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, Thumbs, Grid, EffectCube } from 'swiper/modules';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs, Grid, EffectCube]);
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


export default class extends Controller {
  static values = {
    activeIndex: Number,
  }
  connect() {
    console.log('Swiper controller connected');

    this.element
    new Swiper(".root-swiper", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      loop: true
    });
    const swiper22 = new Swiper('.swiper', {
      // configure Swiper to use modules
      modules: [Navigation, Pagination],

    });

    window.swiperMain = new Swiper('.swiper_main', {
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      autoplay: {
        delay: 1500,
      },
      modules: [Navigation, Pagination]
    });


    //});
    const initial = Number.isFinite(this.activeIndexValue) ? this.activeIndexValue : 0

    this.swiper = new Swiper(this.element, {
      slidesPerView: "auto",
      spaceBetween: 8,
      centeredSlides: true,
      centerInsufficientSlides: true,
      initialSlide: initial,
      slideToClickedSlide: true,
      resistanceRatio: 0.85,
      // loop: true,
      // loopedSlides: 8,
    })

    // На всякий случай: после рендера центрируем ещё раз (иногда полезно при sticky/transition)
    requestAnimationFrame(() => this.swiper.slideTo(initial, 0))
  }

  disconnect() {
    this.swiper?.destroy(true, true)

  }
}